<template>
  <section class="p-2">
    <v-card>
      <v-card>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Voucher Entry</div>
          <div>
            <bread-crumb :bread-crumbs="['Voucher Entry']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
      </v-card>

      <v-card-text>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          :search="search"
          :items="vocherData"
          show-group-by
          group-by="voucher_num"
          dense
          class="mt-5"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
              <div class="d-flex justify-space-between align-items-center py-2">
                <div>
                  <v-btn @click="toggle" x-small icon :ref="group">
                    <v-icon v-if="isOpen">mdi-plus</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                  </v-btn>
                  <span class="mx-5 font-weight-bold">
                    Voucher Reference No: {{ group }}</span
                  >
                </div>
                <div>
                  <v-btn small color="primary" @click="openDialog(group)"
                    >Approve</v-btn
                  >
                </div>
              </div>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="(dialogDelete = true), (deleteId = item.id)"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
    <div class="text-center">
      <v-dialog persistent v-model="Statusdialog" width="500">
        <v-card>
          <v-toolbar dark color="#050048" flat dense>
            <span class="subtitleFontsize">Approve Status</span>
            <v-spacer></v-spacer>
            <v-btn depressed small icon @click="closeStatus()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="mt-2">
            <v-form v-model="valid" ref="UserListtatus">
              <v-row no-gutters class="d-block">
                <v-col md="8">
                  <v-subheader class="required font-weight-bold pl-0 caption"
                    >Approve Status
                  </v-subheader>
                </v-col>
                <v-col cols="12" md="12">
                  <v-select
                    v-model="approveVoucher.status"
                    :items="statusList"
                    :rules="FieldRequired('Status')"
                    placeholder="Status"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <!-- <v-row no-gutters class="d-block">
                <v-col md="8">
                  <v-subheader class="font-weight-bold pl-0 caption"
                    >Effective Date
                  </v-subheader>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="approveVoucher.effective_date"
                    :items="statusList"
                    placeholder="Effective Date"
                    dense
                    type="date"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row> -->
              <v-row no-gutters class="d-block">
                <v-col md="8">
                  <v-subheader class="required font-weight-bold pl-0 caption"
                    >Remarks
                  </v-subheader>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="approveVoucher.remarks"
                    :rules="FieldRequired('Remarks')"
                    placeholder="Enter Remarks"
                    dense
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn depressed color="red" text @click="closeStatus()">
              Cancel
            </v-btn>
            <v-btn depressed rounded color="primary" text @click="save()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
import { FieldRequired } from "@/utils/validation.js";

export default {
  name: "Voucher Not Approved",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  data: () => {
    return {
      FieldRequired,
      loader: false,
      valid: true,
      Statusdialog: false,
      search: "",
      approveVoucher: {
        status: "",
        voucher_num: null,
        // effective_date: new Date().toJSON().split("T")[0],
        remarks: null,
      },
      statusList: [
        { text: "Approve", value: "Approve" },
        { text: "Reject", value: "Reject" },
      ],
      headers: [
        { text: "ID", value: "id", groupable: false },
        { text: "Voucher Name", value: "voucher_name", groupable: false },
        { text: "Txn Type", value: "part_tran_type", groupable: false },
        // { text: "DOT", value: "tran_date", groupable: false },
        { text: "USD", value: "usd_amt", groupable: false },
        { text: "Amount", value: "lc_amt_cr", groupable: false },
        { text: "Txn Currency", value: "trn_currency", groupable: false },
        { text: "Remarks", value: "tran_rmks", groupable: false },
        // { text: "Posted", value: "is_active", groupable: false },
        { text: "Approve", value: "is_active", groupable: false },
        // { text: "Actions", value: "actions" },
      ],
      vocherData: [],
    };
  },
  computed: {},
  mounted() {
    this.getVoucherData();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.vocherData) {
        this.exportToExcel(this.headers, this.vocherData, "partner Route");
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async getVoucherData() {
      this.loader = true;
      try {
        const response = await treasuryService.getVoucherUnapprovedData();
        if (response.data.status_code === 200) {
          this.vocherData = response.data.data;
          this.stoploader();
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
          this.vocherData = [];
        }
        console.log("All routes", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
        this.vocherData = [];
      }
    },

    openDialog(numb) {
      this.Statusdialog = true;
      this.approveVoucher.voucher_num = numb;
    },
    closeStatus() {
      this.Statusdialog = false;
      if (this.$refs.UserListtatus) {
        this.$refs.UserListtatus.resetValidation();
      }
    },
    async save() {
      const validate = this.$refs.UserListtatus.validate();
      if (validate) {
        try {
          const responseData = await treasuryService.approveVoucher({
            approve_status: this.approveVoucher.status,
            voucher_number: this.approveVoucher.voucher_num,
            remarks: this.approveVoucher.remarks,
            // effective_date: this.approveVoucher.effective_date,
          });
          if (responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getVoucherData();
            this.Statusdialog = false;
          } else {
            this.showAlertError(responseData.data.message);
          }
          console.log("respose data", responseData);
        } catch (e) {
          console.error(e);
          this.Statusdialog = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
  },
};
</script>
<style>
.required:after {
  content: " *";
  color: red;
}
</style>
